const firebaseConfig = {
    apiKey: "AIzaSyBI4kIkJPqTwyb6PBKMX8y34GRZ2jlTGd4",
    authDomain: "cinema-hall-project.firebaseapp.com",
    projectId: "cinema-hall-project",
    storageBucket: "cinema-hall-project.appspot.com",
    messagingSenderId: "211926022062",
    appId: "1:211926022062:web:6154a894af42e3d1ac7a3f"
  };

  export default firebaseConfig;